import React from 'react';
import chevronRight from '../images/chevron-right.svg';
import ProgressBar from './ProgressBar';
import { resolveLevel, hasValidScore } from '../../../../assessment/healthSpanScore.utils';

const NO_DATA_COLOR = '#A1A1A1';

const CategoryScoreList = ({ categories, categoryScores, categoryMetadata, scoreDetails, onCategoryClick }) => (
  <div className='list-view'>
    {categories.map((category) => {
      const score = categoryScores[category.id];
      const metadata = categoryMetadata?.[category.id] || null;
      const detail = scoreDetails?.[category.id];
      const hasSubData = detail && Object.keys(detail.subCategories || {}).length > 0;
      const hasData = score !== null && score !== undefined && (score > 0 || hasSubData);
      const level = resolveLevel(hasData ? score : null, metadata);
      const displayColor = hasData ? level.barColor : NO_DATA_COLOR;

      return (
        <button
          type='button'
          className='list-item'
          key={category.id}
          onClick={() => onCategoryClick(category)}
          aria-label={`ดูรายละเอียด ${category.name}`}
        >
          <img className='item-image' src={category.icon} alt={category.name} />
          <div className='item-info'>
            <div className='item-name'>{category.name}</div>
            <div className='item-status' style={{ color: displayColor }}>{hasData ? level.statusText : 'ไม่มีข้อมูล'}</div>
          </div>
          <div className='score-container'>
            <div className='item-score'>
              <div className='score-value' style={{ color: displayColor }}>{hasData ? score : '-'}</div>
              <div className='score-total'>/{level.maxScore}</div>
            </div>
            <ProgressBar value={hasData ? score : 0} maxValue={level.maxScore} barColor={displayColor} />
          </div>
          <img className='chevron-icon' src={chevronRight} alt='' />
        </button>
      );
    })}
  </div>
);

export default CategoryScoreList;
